module.exports = __webpack_public_path__ + "img/clickfunnels_1.fd515f48.png";